import Vue from 'vue'
import Router from 'vue-router'

import store from '../store';

// Manutenção
//const MaintenancePage = () => import ('@/views/MaintenancePage')

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const ResetPassword = () => import('@/views/pages/ResetPassword')
const PasswordChange = () => import('@/views/pages/PasswordChange')
const Register = () => import('@/views/pages/Register')
// const Home = () => import('@/views/pages/Home')

// Users
const Users = () => import('@/views/users/Users')
const User = () => import('@/views/users/User')

const Employees = () => import('@/views/crm/Employees')
const Employee = () => import('@/views/crm/Employee')

const Customers = () => import('@/views/crm/Customers')
const Customer = () => import('@/views/crm/Customer')

const Contacts = () => import('@/views/crm/Contacts')

const Providers = () => import('@/views/crm/Providers')
const Provider = () => import('@/views/crm/Provider')

const Financials = () => import('@/views/financials/Financial')
const RefundNotesCustomers = () => import('@/views/financials/refundnotes/RefundNotesCustomers')
const RefundNotesEmployees = () => import('@/views/financials/refundnotes/RefundNotesEmployees')
const ExpensesNotesEmployees = () => import('@/views/financials/refundnotes/ExpensesNotesEmployees')
const RefundNoteDetails = () => import('@/views/financials/RefundNoteDetails')
const RefundNoteDetailsPrint = () => import('@/views/financials/RefundNoteDetailsPrint')
const RefundNoteEmployeeDetails = () => import('@/views/financials/RefundNoteEmployeeDetails')
const RefundNoteEmployeeDetailsPrint = () => import('@/views/financials/RefundNoteEmployeeDetailsPrint')
const RefundExpenseNoteDetails = () => import('@/views/financials/RefundExpenseNoteDetails')
const RefundExpenseNoteDetailsPrint = () => import('@/views/financials/RefundExpenseNoteDetailsPrint')
const IssueInvoice = () => import('@/views/financials/IssueInvoice')
const Invoices = () => import ('@/views/financials/Invoices')

const Contracts = () => import('@/views/contracts/Contracts')
const Contract = () => import('@/views/contracts/Contract')

const Timesheet = () => import('@/views/timesheet/Timesheet')
const TimesheetReports = () => import('@/views/timesheet/TimesheetReports')
const TimesheetReportsAdd = () => import('@/views/timesheet/TimesheetReportsAdd')
const TimesheetReportsDetails = () => import('@/views/timesheet/TimesheetReportsDetails')
const TimesheetReportsPrint = () => import('@/views/timesheet/TimesheetReportsPrint')

const Folders = () => import('@/views/folders/Folders')

Vue.use(Router)

function configRoutes() {
  return [
    //{
      //path: "/maintenance",
      //name: "Maintenance",
      //component: MaintenancePage,
    //},
    {
      path: '/account/login',
      name: 'Login',
      component: Login,
      meta: {
        auth: false,
        title: 'Login'
      },
    },
    {
      path: '/account/reset',
      name: 'ResetPassword',
      component: ResetPassword,
      meta: {
        auth: false,
        title: 'Reset Senha'
      },
    },
    {
      path: '/account/reset/token/:token',
      name: 'PasswordChange',
      component: PasswordChange,
      meta: {
        auth: false,
        title: 'Mudança de Senha'
      },
    },
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: DefaultContainer,
      meta: {
        auth: true,
      },
      children: [
        {
          path: '/dashboard',
          name: 'Dashboard',
          component: Dashboard,
          meta: {
            title: 'Dashboard'
          }
        },
        {
          path: '/crm/employees',
          name: 'Funcionários',
          component: Employees,
          meta: {
            title: 'Funcionários'
          }
        },
        {
          path: '/crm/employees/:pk',
          name: 'Funcionário',
          component: Employee,
          meta: {
            title: 'Funcionário'
          }
        },
        {
          path: '/crm/customers',
          name: 'Clientes',
          component: Customers,
          meta: {
            title: 'Clientes'
          }
        },
        {
          path: '/crm/customers/:pk',
          name: 'Cliente',
          component: Customer,
          meta: {
            title: 'Cliente'
          }
        },
        {
          path: '/crm/contacts',
          name: 'Contatos',
          component: Contacts,
          meta: {
            title: 'Contatos'
          }
        },
        {
          path: '/crm/providers',
          name: 'Fornecedores',
          component: Providers,
          meta: {
            title: 'Fornecedores'
          }
        },
        {
          path: '/crm/providers/:pk',
          name: 'Fornecedor',
          component: Provider,
          meta: {
            title: 'Fornecedor'
          }
        },
        {
          path: '/financials/financials',
          name: 'Financeiro',
          component: Financials,
          meta: {
            title: 'Financeiro'
          }
        },
        {
          path: '/financials/refund_notes_customers',
          name: 'Notas de Reembolso dos Clientes',
          component: RefundNotesCustomers,
          meta: {
            title: 'NR Clientes'
          }
        },
        {
          path: '/financials/refund_notes_employees',
          name: 'Notas de Reembolso dos Funcionários',
          component: RefundNotesEmployees,
          meta: {
            title: 'NR Funcionários'
          }
        },
        {
          path: '/financials/expenses_notes_employees',
          name: 'Notas de Despesas da Fonte Pagadora',
          component: ExpensesNotesEmployees,
          meta: {
            title: 'Lista NR Funcionários'
          }
        },
        {
          path: '/financials/repayment/:pk',
          name: 'Nota de Reembolso',
          component: RefundNoteDetails,
          meta: {
            auth: {
              disallow: ['simpleuser'],
            },
            title: 'Nota de Reembolso'
          }
        },
        {
          path: '/financials/repayment/:pk/print',
          name: 'Impressão de Nota de Reembolso',
          component: RefundNoteDetailsPrint,
          meta: {
            auth: {
              disallow: ['simpleuser'],
            },
            title: 'Impressão'
          }
        },
        {
          path: '/financials/repayment/employee/:pk',
          name: 'Nota de Reembolso do Funcionário',
          component: RefundNoteEmployeeDetails,
          meta: {
            auth: {
              disallow: ['simpleuser'],
            },
            title: 'NR Funcionário'
          }
        },
        {
          path: '/financials/repayment/employee/:pk/print',
          name: 'Impressão de Nota de Reembolso do Funcionário',
          component: RefundNoteEmployeeDetailsPrint,
          meta: {
            auth: {
              disallow: ['simpleuser'],
            },
            title: 'Impressão NR Funcionário'
          }
        },
        {
          path: '/financials/repayment/expense-note/:pk',
          name: 'Nota de Reembolso da Fonte Pagadora',
          component: RefundExpenseNoteDetails,
          meta: {
            auth: {
              disallow: ['simpleuser'],
            },
          }
        },
        {
          path: '/financials/repayment/expense-note/:pk/print',
          name: 'Impressão de Nota de Reembolso da Fonte Pagadora',
          component: RefundExpenseNoteDetailsPrint,
          meta: {
            auth: {
              disallow: ['simpleuser'],
            },
          }
        },
        {
          path: '/contracts',
          name: 'Contratos',
          component: Contracts,
          meta: {
            title: 'Contratos'
          }
        },
        {
          path: '/contracts/:pk',
          name: 'Contrato',
          component: Contract,
          meta: {
            title: 'Contrato'
          }
        },
        {
          path: '/timesheet/timesheet',
          name: 'Timesheet',
          component: Timesheet,
          meta: {
            title: 'Timesheet'
          }
        },
        {
          path: '/timesheet/report',
          name: 'Relatórios de Timesheet',
          component: TimesheetReports,
          meta: {
            auth: {
              disallow: ['simpleuser'],
            },
            title: 'Relatórios Timesheet'
          }
        },
        {
          path: '/timesheet/report/add',
          name: 'Criar Relatório de Timesheet',
          component: TimesheetReportsAdd,
          meta: {
            auth: {
              disallow: ['simpleuser'],
            },
            title: 'Criar Relatório Timesheet'
          }
        },
        {
          path: '/timesheet/report/detail/:pk',
          name: 'Detalhes do Relatório de Timesheet',
          component: TimesheetReportsDetails,
          meta: {
            auth: {
              disallow: ['simpleuser'],
            },
            title: 'Detalhes do Relatório de Timesheet'
          }
        },
        {
          path: '/timesheet/report/detail/:pk/print',
          name: 'Detalhes do Relatório de Timesheet Print',
          component: TimesheetReportsPrint,
          meta: {
            auth: {
              disallow: ['simpleuser'],
            },
            title: 'Impressão Relatório de Timesheet'
          }
        },
        {
          path: '/folder/folders',
          name: 'Pastas',
          component: Folders,
          meta: {
            title: 'Pastas'
          }
        },
        {
          path: '/emitir-nota-fiscal',
          name: 'Emitir Nota Fiscal',
          component: IssueInvoice,
          meta : {
            title: 'Emitir Nota Fiscal'
          }
        },
        {
          path: '/notas-fiscais',
          name: 'Notas Fiscais',
          component: Invoices,
          meta: {
            title: 'Notas Fiscais'
          }
        }

      ]
    }
  ]
}

const router = new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  base: '/app/',
  routes: configRoutes()
})

router.beforeEach((to, from, next) => {

  document.title = `${to.meta.title ? `${to.meta.title} | PGSA` : 'PGSA'}`;

  let user = store.state.auth.user;

  // Get the main route auth meta
  // Such as, access the dashboard only if it's authenticated
  // meta: { auth: true }
  let auth = to.matched[0] && to.matched[0].meta && to.matched[0].meta.auth;

  function authCheck() {
    if (auth && (!user || !user.pk)) {
      router.push('/account/login');
      return;
    }

    if (auth == false && user && user.pk) {
      router.push('/dashboard');
      return;
    }

    // Get the sub route auth meta
    // Such as, access the reports only if is not a simpleuser
    // meta: { auth: { disallow: ['simpleuser'] } }
    auth = to.matched[1] && to.matched[1].meta && to.matched[1].meta.auth;

    if (auth && auth.disallow) {
      if (user.groups.some(g => auth.disallow.includes(g.name))) {
        router.push('/dashboard');
        return;
      }
    }

    next();
  }

  if (!user) {
    store.dispatch('auth/checkUser', {
      callback: () => {
        user = store.state.auth.user;

        authCheck();
      }
    });

    return;
  }

  authCheck();
});

export default router;
